import { Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { LinkedEvent } from '../../../models/post';
import { eventWhenLabel } from '../../../helpers/event-helpers';

/**
 * The events linked to a post, each a link that opens it on the calendar.
 * The calendar picks up `?eventId=` and jumps to and opens that event.
 */
@Component({
  selector: 'app-linked-events',
  imports: [RouterLink, MatIconModule],
  templateUrl: './linked-events.html',
  styleUrl: './linked-events.css',
})
export class LinkedEvents {
  /**
   * The post's linked events. Nothing renders when empty or missing — a post
   * that didn't come through Post.digest has no list at all.
   */
  @Input() set events(value: LinkedEvent[] | null | undefined) {
    this.linked = value ?? [];
  }

  /** The events to show. */
  linked: LinkedEvent[] = [];

  /** The viewer's calendar route, e.g. '/students/calendar'. */
  @Input({ required: true }) calendarPath!: string;

  /**
   * @param {LinkedEvent} event
   * @returns {string} e.g. "Oct 23, 2026, 1:45 PM"
   */
  whenLabel(event: LinkedEvent): string {
    return eventWhenLabel(event.day, event.start_time);
  }
}
